import React, { FunctionComponent, useCallback, useContext, useState } from "react";
import { Grid, IconButton, TextField, Tooltip } from "@material-ui/core";
import { OpenInNew } from "@material-ui/icons";
import { RouteStopEventImageFragment } from "../../../api/nachfahrbarkeit-api/generated";
import { useTranslation } from "react-i18next";
import { CustomLightBox, IImage } from "../../../components/lightbox/custom-lightbox";
import moment from "moment";
import { EditRouteStopsContext } from "./edit-route-stops.context";

interface IRouteDetailsMapInfoWindowInfoProps {
  info: string | undefined;
  onInfoChange: (info: string) => void;
  images: RouteStopEventImageFragment[];
}

export const RouteDetailsMapInfoWindowInfo: FunctionComponent<IRouteDetailsMapInfoWindowInfoProps> = (props) => {
  const { info, onInfoChange, images } = props;
  const { isInEditMode } = useContext(EditRouteStopsContext);

  const { t } = useTranslation();
  const [showImages, setShowImages] = useState<boolean>(false);

  const getImagesFromStopEvents = useCallback((): IImage[] => {
    return images.map((image) => ({
      url: image.url,
      title: info ?? null,
      caption: moment(image.inserted_at).format(t("date_time.date_time_seconds_format")),
      typeId: "",
    }));
  }, [info, images, t]);

  return (
    <>
      {showImages && (
        <CustomLightBox
          images={getImagesFromStopEvents()}
          onClose={() => {
            setShowImages(false);
          }}
        />
      )}
      <Grid item xs>
        <TextField
          id="addInfo"
          value={info || ""}
          onChange={(ev) => {
            onInfoChange(ev.target.value);
          }}
          required
          fullWidth
          disabled={!isInEditMode}
        />
      </Grid>
      {!!images.length && (
        <Grid item xs={3}>
          <Tooltip placement="top" title={t("routes_management.open_images") as string}>
            <IconButton
              onClick={() => {
                setShowImages(true);
              }}
            >
              <OpenInNew />
            </IconButton>
          </Tooltip>
        </Grid>
      )}
    </>
  );
};
